module.exports = __webpack_public_path__ + "dbd2262493a514594a10ea9a365c7713.svg";